import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import IndexPage from "./index/Index";
import SearchFilePage from "./search/SearchFilePage";
import FilePage from "./search/FilePage";
import CustomPage from "./search/Custom";
import SearchFilePageZGFX from "./search/SearchFilePageZGFX";
import LawPage from "./search/Law";
import Subscribe from "./subscribe/Subscribe";
import Info from "./search/Info";
import PublishList from "./publish/Publish";
import Inheritance from "./inheritance/Inheritance";
import Assembly from "./assembly/Assembly";
import ReviewExport from "./reviewExport/ReviewExport";
import UserCenter from "./user/UserCenter";
import DataClass from "./dataClass/DataClass";
import WorkFlow from "./workFlow/WorkFlow";
import Cma from "./cma/Cma";
import AccessProblem from "./accessProblem/AccessProblem";
import PracticalLink from "./practicalLink/PracticalLink";
import Tracker from "./search/Tracker";
import Blank from "./Blank";
import CompetitiveProducts from "./competitiveProducts/CompetitiveProducts";
import LawDetail from "./lawDetail/LawDetail";
import FlyCheck from "./flyCheck/FlyCheck";
import PunishDoc from "./punishDoc/PunishDoc";
import SceneCheck from "./sceneCheck/SceneCheck";
import CompositeSearch from "./search/CompositeSearch";
import Classify from "./classify/Classify";
import MonitorPage from "./monitor/Monitor";
import TrainPage from "./train/Train";
import InnovatePage from "./innovate/Innovate";
import MedicalEquipmentPage from "./medicalEquipment/MedicalEquipment";
import StandardSubstancePage from "./standardSubstance/StandardSubstance";
import ReviewSummaryPage from "./reviewSummary/ReviewSummary";
import TranslatePage from './translate/Translate'

export default class Homepage extends Component {
  render() {
    return (
      <Router>
        <Layout>
          <Switch>
            <Route path="/law" key="law" component={SearchFilePage} />
            <Route path="/commonProblems" key="commonProblems" component={SearchFilePage} />
            <Route path="/issues" key="issues" component={SearchFilePage} />
            <Route path="/compare" key="compare" component={SearchFilePage} />
            <Route path="/fda" key="fda" component={SearchFilePage} />
            <Route path="/standard" key="standard" component={SearchFilePage} />
            <Route path="/guidance" key="guidance" component={SearchFilePage} />
            <Route path="/search" key="search" component={SearchFilePage} />
            {/* <Route path="/news" key="news" component={SearchFilePage} /> */}
            <Route path="/market" key="market" component={FilePage} />
            <Route path="/yrdCenter" key="yrdCenter" component={FilePage} />
            <Route path="/gbaCenter"  key="gbaCenter"  component={FilePage} />
            <Route path="/medical" key="medical" component={FilePage} />
            <Route path="/fileClass" key="fileClass" component={LawPage} />
            <Route path="/dataClass" component={DataClass} />
            <Route path="/workFlow" component={WorkFlow} />
            <Route path="/subscribe" component={Subscribe} />
            <Route path="/info" component={Info} />
            <Route path="/innovate" component={InnovatePage} />
            <Route path="/reviewSummary" component={ReviewSummaryPage} />
            <Route path="/medicalEquipment" component={MedicalEquipmentPage} />
            <Route path="/standardSubstance" component={StandardSubstancePage} />
            <Route path="/report" component={Blank} />
            <Route path="/monitor" key="monitor" component={MonitorPage} />
            <Route path="/train" key="train" component={TrainPage} />
            <Route path="/gather" key="gather" component={Tracker} />
            <Route path="/news" key="news" component={Tracker} />
            <Route path="/custom" key="custom" component={CustomPage} />
            <Route path="/product" component={CompetitiveProducts} />
            <Route path="/lawDetail" component={LawDetail} />
            <Route path="/publish" component={PublishList} />
            <Route path="/assembly" component={Assembly} />
            <Route path="/inheritance" component={Inheritance} />
            <Route path="/reviewExport" component={ReviewExport} />
            <Route path="/cma" component={Cma} />
            <Route path="/accessProblem" component={AccessProblem} />
            <Route path="/practicalLink" component={PracticalLink} />
            <Route path="/userCenter" component={UserCenter} />
            <Route path="/classify" component={Classify} />

            <Route path="/flyCheck" component={FlyCheck} />
            <Route path="/punishDoc" component={PunishDoc} />
            <Route path="/sceneCheck" component={SceneCheck} />
            <Route path="/compositeSearch" component={CompositeSearch} />
            <Route path="/index" key="index" component={IndexPage} />
            <Route path="/translate" key="index" component={TranslatePage} />
            <Route path="/" key="home" component={IndexPage} />
          </Switch>
        </Layout>
      </Router>
    );
  }
}
